import { FC } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Title } from 'react-admin';
export const Dashboard: FC = () => (
  <Card>
    <Title title="Axioum" />
    <CardContent>
      <h1>Система управления интеграции интеллектуальных консультантов</h1>
    </CardContent>
  </Card>
);
